var map = {
	"./image-product-1-thumbnail.jpg": 418,
	"./image-product-2-thumbnail.jpg": 652,
	"./image-product-3-thumbnail.jpg": 478,
	"./image-product-4-thumbnail.jpg": 916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 913;